var map = {
	"./pdf.png": "./src/assets/icons/resourceType/pdf.png",
	"./video.png": "./src/assets/icons/resourceType/video.png",
	"./webpage.png": "./src/assets/icons/resourceType/webpage.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/resourceType sync recursive ^\\.\\/.*\\.png$";